// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var WaterMetersService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function WaterMetersService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get water meters list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    WaterMetersService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "condo-structures/water-meters-list", params);
    };
    /**
     * Get an exportation file of water meters
     *
     * @since 1.0.0
     */
    WaterMetersService.prototype.getExport = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'condo-structures/water-meters-list-export', params, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get all WaterMeters of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    WaterMetersService.prototype.getWaterMeters = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "condo-structures/water-meters")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    WaterMetersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WaterMetersService_Factory() { return new WaterMetersService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: WaterMetersService, providedIn: "root" });
    return WaterMetersService;
}());
export { WaterMetersService };
